export const incrementPollingCount =() => ({
    type: 'INCREMENT_POLLING_COUNT',
})

export const decrementPollingCount =() => ({
    type: 'DECREMENT_POLLING_COUNT',
})

export const resetPollingCount =() => ({
    type: 'RESET_POLLING_COUNT',
})